import { useToast, modals } from '@cad-arc';
import { v4 } from 'uuid';
import { useIntegratedActionBroadcaster } from '../action-broadcaster/use-integrated-action-broadcaster';
import { useBroadcast } from '../common/broadcast-channel/use-broadcast';
import { useApplicationType } from '../common/hooks/use-application-type';
import { electronBridge } from '../electron-bridge/electron-bridge';
import { EventInfo } from '~/common/broadcast-channel/types';

export function useProQaErrorsListener() {
    const { isWeb } = useApplicationType();
    const toast = useToast();
    const { trigger } = useIntegratedActionBroadcaster();

    const moveFocusToProQa = (agencyType: 'FIRE' | 'EMS' | 'POLICE', eventInfo: EventInfo) => {
        trigger([
            {
                id: v4(),
                targetWindowType: 'ROOT',
                type: 'FOCUS_ON_PRO_QA',
                payload: {
                    type: agencyType,
                    eventInfo,
                },
            },
        ]);
    };

    useBroadcast('legacy-store-broadcast', (message) => {
        if (message.type === 'PRO_QA_ERROR_MESSAGE') {
            if (isWeb || electronBridge?.args['--workspace-window-type'] === 'EVENT_V2') {
                toast({
                    status: 'error',
                    description: message.payload,
                });
            }
        }
    });
    useIntegratedActionBroadcaster({
        windowType: 'EVENT_V2',
        ignoreActiveWorkspaceWindowType: isWeb,
        handler(action) {
            if (action.type === 'PRO_QA_ERROR_MESSAGE') {
                toast({
                    status: 'error',
                    description: action.payload,
                });
                return true;
            }
            if (action.type === 'PRO_QA_SESSION_ALREADY_IN_USE') {
                modals.confirm({
                    title: 'ProQA Session Error',
                    body: `ProQA is still active with case #${action.payload.incidentId ?? ''}.\n Please close that case and re-launch ProQA`,
                    confirmLabel: 'OK',
                    onConfirm: () => {
                        moveFocusToProQa(action.payload.agencyType, action.payload.eventInfo);
                    },
                    onCancel: () => {
                        moveFocusToProQa(action.payload.agencyType, action.payload.eventInfo);
                    },
                });
                return true;
            }
        },
    });
    return null;
}
